/**
 * Слова длиной 5–6 символов, попадающие в catch-all паттерн `/:link/` страницы
 * pages/[link].vue, но являющиеся служебными/зарезервированными. Шорт-линки
 * с такими кодами не должны разрешаться — отдаём 404, чтобы поисковики не
 * индексировали страницы вида /queue/, /admin/ и т.п.
 */
export const RESERVED_SHORT_LINK_CODES = new Set<string>([
    'queue',
    'admin',
    'login',
    'logout',
    'cabinet',
    'signin',
    'signup',
    'search',
    'static',
    'public',
    'assets',
    'share',
    'fest4l',
]);

export function isReservedShortLinkCode(code: string | undefined | null): boolean {
    if (!code) return false;
    return RESERVED_SHORT_LINK_CODES.has(code.toLowerCase());
}
